export default {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_LOGOUT: "LOGIN_LOGOUT",
};



// WEBPACK FOOTER //
// ./src/redux/types/user.js